"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.execute = void 0;
const childProcess = require("child_process");
const debug_1 = require("./debug");
const shescape_1 = require("shescape");
function execute(command, args, options) {
    (0, debug_1.debug)(`running "${command} ${args.join(' ')}"`);
    const spawnOptions = { shell: true };
    if (options && options.cwd) {
        spawnOptions.cwd = options.cwd;
    }
    args = (0, shescape_1.quoteAll)(args, spawnOptions);
    return new Promise((resolve, reject) => {
        var _a, _b;
        let stdout = '';
        let stderr = '';
        const proc = childProcess.spawn(command, args, spawnOptions);
        (_a = proc.stdout) === null || _a === void 0 ? void 0 : _a.on('data', (data) => {
            stdout = stdout + data;
        });
        (_b = proc.stderr) === null || _b === void 0 ? void 0 : _b.on('data', (data) => {
            stderr = stderr + data;
        });
        proc.on('close', (code) => {
            if (code !== 0) {
                (0, debug_1.debug)(`Error running "${command} ${args.join(' ')}", exit code: ${code}`);
                return reject(stdout || stderr);
            }
            (0, debug_1.debug)(`Sub process stderr:`, stderr);
            resolve(stdout || stderr);
        });
    });
}
exports.execute = execute;
//# sourceMappingURL=sub-process.js.map